
(function(){
  if(customElements.get("mc-size-guide")) return;
  var FLAT_MAP_URL="https://cdn.maisoncanvas.com/designs/flat-map.json";
  var _mapP=null;
  function loadMap(){ if(_mapP) return _mapP; _mapP=fetch(FLAT_MAP_URL,{cache:"force-cache"}).then(function(r){return r.ok?r.json():{};}).catch(function(){return {};}); return _mapP; }

  var CAL={ REF_LEFT:21.4, REF_RIGHT:79.9, REF_INCHES:69, HUMAN_TOP:36, HUMAN_BOTTOM:93, HUMAN_INCHES:67, EYE_IN:58, ANCHOR_X:49, DEF:"16x20" };
  var PCT_PER_IN_V=(CAL.HUMAN_BOTTOM-CAL.HUMAN_TOP)/CAL.HUMAN_INCHES;
  var CENTER_Y=CAL.HUMAN_BOTTOM - CAL.EYE_IN*PCT_PER_IN_V;

  function init(root){
    if(root._mcsgInit) return;
    var link=root._mcsgLink || root.querySelector("[data-open]");
    var modal=root._mcsgModal || root.querySelector("[data-modal]");
    root._mcsgModal=modal;
    if(!link || !modal) return;
    root._mcsgInit=true;
    var lifecycle = new AbortController();
    root._mcsgAbort = lifecycle;
    var raf, opener, previousOverflow;
    function listen(target,type,fn,options){ target?.addEventListener(type,fn,Object.assign({},options,{signal:lifecycle.signal})); }
    var stage=modal.querySelector("[data-stage]"), art=modal.querySelector("[data-art]"), sizesEl=modal.querySelector("[data-sizes]");
    var handle=root.getAttribute("data-handle")||"", fallback=root.getAttribute("data-fallback")||"";
    var SIZES=[], cur=CAL.DEF, imgSet=false;
    function syncSizes(){
      var info=root.closest('product-info');
      var picker=info && Array.from(info.querySelectorAll('variant-selects')).find(function(node){return node.getClientRects().length && node.style.display!=='none';});
      var next=Array.from(picker ? picker.querySelectorAll('.mc-size-options input') : []).map(function(input){
        var match=input.value.replace(/×/g,'x').match(/(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)/);
        return match ? {id:match[1]+'x'+match[2],w:Number(match[1]),h:Number(match[2])} : null;
      }).filter(Boolean);
      if(JSON.stringify(next)===JSON.stringify(SIZES)) return;
      SIZES=next;
      if(!SIZES.some(function(size){return size.id===cur;})) cur=(SIZES.find(function(size){return size.id===CAL.DEF;}) || SIZES[0])?.id;
      sizesEl.replaceChildren();
      renderSizes();
      apply();
    }
    root._mcsgSyncSizes=syncSizes;

    function setArt(){
      if(imgSet) return;
      loadMap().then(function(map){
        if(lifecycle.signal.aborted || !root.isConnected) return;
        var url=(map && map[handle]) ? map[handle] : fallback; if(!url) return;
        var img=document.createElement("img"); img.src=url; img.alt=root.getAttribute("data-title") || "Artwork";
        art.innerHTML=""; art.appendChild(img); imgSet=true; apply();
      });
    }

    function renderSizes(){ SIZES.forEach(function(s){
      var b=document.createElement("button"); b.type="button";
      b.className="mcsg-size"+(s.id===cur?" on":""); b.textContent=s.w+"\u00d7"+s.h+"\u2033";
      b.onclick=function(){ cur=s.id; sizesEl.querySelectorAll(".mcsg-size").forEach(function(x){x.classList.remove("on");}); b.classList.add("on"); apply(); centerBtn(b); };
      sizesEl.appendChild(b);
    }); }
    syncSizes();

    function curSize(){ for(var i=0;i<SIZES.length;i++) if(SIZES[i].id===cur) return SIZES[i]; return SIZES[0]; }
    function apply(){
      var w=stage.clientWidth; if(!w) return;
      var ppi=(CAL.REF_RIGHT-CAL.REF_LEFT)/100*w/CAL.REF_INCHES;
      var s=curSize(); if(!s) return;
      art.style.width=(s.w*ppi)+"px"; art.style.height=(s.h*ppi)+"px";
      art.style.left=CAL.ANCHOR_X+"%"; art.style.top=CENTER_Y+"%";
    }
    function centerBtn(b){ if(window.innerWidth>=1024) return; sizesEl.scrollTo({left:b.offsetLeft-sizesEl.clientWidth/2+b.clientWidth/2,behavior:"smooth"}); }

    var arrow=modal.querySelector("[data-arrow]"), fade=modal.querySelector("[data-fade]");
    function updArrow(){ if(window.innerWidth>=1024) return; var end=sizesEl.scrollLeft+sizesEl.clientWidth>=sizesEl.scrollWidth-4; if(arrow) arrow.classList.toggle("hide",end); if(fade) fade.classList.toggle("hide",end); }
    listen(arrow,"click", function(){ sizesEl.scrollBy({left:sizesEl.clientWidth*0.7,behavior:"smooth"}); });
    listen(sizesEl,"scroll", updArrow, {passive:true});

    function ensureBody(){ if(modal.parentNode!==document.body){ document.body.appendChild(modal); } }
    function open(){
      if(modal.classList.contains("show")) return;
      syncSizes(); ensureBody(); opener=document.activeElement; previousOverflow=document.body.style.overflow;
      modal.classList.add("show"); document.body.style.overflow="hidden"; setArt();
      raf=requestAnimationFrame(function(){ if(!lifecycle.signal.aborted){ apply(); updArrow(); modal.querySelector('button[data-close]').focus({preventScroll:true}); } });
    }
    function close(){
      if(!modal.classList.contains("show")) return;
      cancelAnimationFrame(raf); modal.classList.remove("show"); document.body.style.overflow=previousOverflow;
      if(opener?.isConnected) opener.focus({preventScroll:true});
    }
    root._mcsgClose=close;
    root._mcsgOpen = open;
    modal.querySelectorAll("[data-close]").forEach(function(el){ listen(el,"click",close); });
    listen(document,"keydown", function(e){
      if(!modal.classList.contains("show")) return;
      if(e.key==="Escape"){e.preventDefault();close();}
      if(e.key==="Tab"){
        var buttons=Array.from(modal.querySelectorAll('button')).filter(function(b){return b.getClientRects().length && !b.disabled;});
        if(buttons.length){e.preventDefault();var i=buttons.indexOf(document.activeElement);buttons[(i+(e.shiftKey?-1:1)+buttons.length)%buttons.length].focus({preventScroll:true});}
      }
    });
    listen(window,"resize", function(){ if(modal.classList.contains("show")){ apply(); updArrow(); } });
    root._mcsgLink=link;
    var info=root.closest('product-info');
    listen(info,'click',function(event){if(event.target.closest('.mcsg-link')){event.preventDefault();open();}});
    listen(info,'mc:picker-ready',function(){syncSizes();placeLink(root);});
    root._mcsgDispose=function(){close();lifecycle.abort();cancelAnimationFrame(raf);modal.remove();root._mcsgInit=false;};
    placeLink(root);
  }

  function placeLink(root){
    var link=root._mcsgLink; if(!link) return;
    var legend=null;
    var scope=root.closest('product-info') || document;
    var pickers=scope.querySelectorAll('variant-selects');
    for(var i=0;i<pickers.length;i++){
      if(!pickers[i].getClientRects().length || pickers[i].style.display==='none') continue;
      var field=pickers[i].querySelector('.mc-size-options');
      if(field){ legend=field.querySelector('legend'); if(legend) break; }
    }
    if(!legend) return;
    if(legend.querySelector(".mcsg-link")) return;
    legend.appendChild(link);
  }

  customElements.define('mc-size-guide',class extends HTMLElement {
    connectedCallback(){init(this);}
    disconnectedCallback(){this._mcsgDispose?.();this._mcsgDispose=null;this._mcsgOpen=null;this._mcsgClose=null;this._mcsgSyncSizes=null;}
  });
})();
